<template>
  <div class="wrapper">
    <div class="header">
      <div class="header__content">
        <div class="header__content__item">
          <a :href="performancePage">
            <img
              class="logo"
              alt="logo"
              src="@/assets/images/icons/blibli-affiliate-icon.svg"
            >
          </a>
          <BliTooltip
            data-testid="profile-tooltip"
            position="bottom-left"
            hover-content
          >
            <template #label>
              <div class="content-left">
                <BliIconSiPeopleProfile
                  class="content-left__icon"
                />
                <div class="content-left__name">
                  {{ $t('header.name', { name: firstname }) }}
                </div>
              </div>
            </template>
            <template #content>
              <div class="content-left__header">
                <BliIconSiPeopleProfile
                  class="content-left__header__icon"
                />
                <div class="content-left__header__text">
                  <span class="content-left__header__text--name">
                    {{ name }}
                  </span>
                  <span class="content-left__header__text--company">
                    {{ company }}
                  </span>
                </div>
              </div>
              <BliLists class="content-left__dropdown">
                <BliList
                  data-testid="setting-button"
                  @click="redirectToSettingPage"
                >
                  <div class="content-left__dropdown__item">
                    <BliIconSiSetting />{{ $t('header.action.setting') }}
                  </div>
                </BliList>
                <BliList
                  data-testid="logout-button"
                  @click="doLogout"
                >
                  <div class="content-left__dropdown__item">
                    <BliIconSiLogOut />{{ $t('header.action.logout') }}
                  </div>
                </BliList>
              </BliLists>
            </template>
          </BliTooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./js/header">
</script>

<style scoped lang="scss">
.wrapper {
  border-bottom: solid 1px $blu-color-neutral-border-med;
  .header {
    background: $blu-color-neutral-background-default;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    -webkit-font-smoothing: antialiased;
    &__content {
      display: flex;
      width: 100%;
      height: 64px;
      justify-content: space-between;
      align-items: center;
      flex-shrink: 0;
      &__item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 60px;
        flex: 1 0 0;
        .logo {
          display: flex;
          padding-right: 24px;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
        }
        .content-left:hover{
          background-color: $blu-color-neutral-border-low;
        }
        .content-left {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 8px;
          padding: 8px;
          border-radius: 8px;
          width: 100%;
          cursor: pointer;
          &__header {
          display: flex;
          align-items: center;
          padding: 12px 12px 12px 8px;
          gap: 10px;
          &__text {
            display: flex;
            flex-direction: column;
            &--name {
              font: $blu-text-subtitle-1;
              width: 220px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            &--company {
              font: $blu-text-body-2;
            }
          }
          &__icon {
            width: 32px;
            height: 32px;
          }
        }
        &__icon {
            fill: $blu-color-neutral-icon-default;
          }
          &__profile {
            border-radius: 46px;
            height: 46px;
            flex-shrink: 0;
          }
          &__name {
            color: $blu-color-neutral-text-high;
            font: $blu-text-subtitle-2;
          }
          &__dropdown {
            width: 100%;
            &__item {
              display: flex;
              gap: 6px;
            }
          }
        }
      }
    }
  }
}
</style>
